import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SecretService {
  private $betterErrors = new BehaviorSubject<boolean>(localStorage.getItem('betterErrors') === 'true');

  get betterErrors$() {
    return this.$betterErrors.asObservable();
  }

  get betterErrors(): boolean {
    return this.$betterErrors.value;
  }

  set betterErrors(value: boolean) {
    localStorage.setItem('betterErrors', value.toString());
    this.$betterErrors.next(value);
  }
}
